<template>
  <v-container>
    <v-layout>
    <v-flex>
      <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newProcedure"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Procedimiento</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo Procedimiento</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                    v-model="procedure.name"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                          name="description"
                          label="Descripción"
                          id="description"
                          :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                          v-model="procedure.description"
                          required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-select
                          :items="this.$store.getters.getProviders"
                          v-model="providerQuito"
                          label="Proveedor Quito"
                          single-line
                          item-text="name"
                          item-value="id"
                          :rules="[v => !!v || 'Campo requerido']"
                          return-object
                          persistent-hint
                          required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-select
                          :items="this.$store.getters.getProviders"
                          v-model="providerGuayaquil"
                          label="Proveedor Guayaquil"
                          single-line
                          item-text="name"
                          item-value="id"
                          :rules="[v => !!v || 'Campo requerido']"
                          return-object
                          persistent-hint
                          required
                          v-on:keyup.enter="saveData"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData" large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Procedimientos</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.procedures"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td>
            <v-tooltip top >
              <v-btn
              fab dark
              small @click="editItem(props.item)"
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
import Procedure from "../../model/Procedure";
import Provider from "../../model/Provider";

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Descripción', value: 'description' },
        { text: 'Acciones', value: 'actions' }
      ],
      editedIndex: -1,
      procedure: new Procedure(),
      providerQuito: new Provider(),
      providerGuayaquil: new Provider()
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.procedure = new Procedure();
      this.providerQuito= new Provider();
      this.providerGuayaquil= new Provider();
      this.valid = false;
      this.dialog = false;
    },
    newProcedure() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.providerQuito= new Provider();
      this.providerGuayaquil= new Provider();
      this.$refs.form.reset();
      this.procedure = new Procedure();
    },
    saveData() {
      if (this.$refs.form.validate()) {
        this.procedure.providerQuito = this.providerQuito.id
        this.procedure.providerGuayaquil = this.providerGuayaquil.id
        if (this.editedIndex > -1) {
          this.$store.dispatch('updateProcedure', this.procedure).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        } else {
          this.$store.dispatch('addProcedure', this.procedure).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        }
        this.dialog = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.$store.state.procedures.indexOf(item);
      this.procedure = Object.assign({}, item);
      for(let i=0; i<this.$store.state.providers.length;i++){
        this.providerQuito = this.$store.state.providers[i]
        let hasProviderQuito= false
        if(this.providerQuito.id===this.procedure.providerQuito){
          hasProviderQuito = true
          break
        }
        if(!hasProviderQuito){
          this.providerQuito=new Provider
        }
      }
      for(let i=0; i<this.$store.state.providers.length;i++){
        this.providerGuayaquil = this.$store.state.providers[i]
        let hasProviderGuayaquil= false
        if(this.providerGuayaquil.id===this.procedure.providerGuayaquil){
          hasProviderGuayaquil = true
          break
        }
        if(!hasProviderGuayaquil){
          this.providerGuayaquil=new Provider
        }
      }
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.$store.state.procedures.indexOf(item);
      this.procedure = Object.assign({}, item);
      confirm('Está seguro de que quiere eliminar el registro?') &&
        this.$store.dispatch('deleteProcedure', this.procedure.id);
    }
  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getProcedures').then(
      response => {
        this.cleanData();
      },
      error => {
        this.$store.state.dialogError = true;
      }
    );
    this.$store.dispatch('getProviders').then(response => {})
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/procedure/Procedure.vue